import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoggerService, AuthService, ProductActions, tryNormalizeHttpError } from '@spartacus/core';
import { concatMap, of, delay, switchMap, filter, EMPTY, from, mergeMap, catchError, map } from 'rxjs';
import { ApiService } from '../../../../SGRE-shared/services/api.service';
import { CustomProductActions } from '../action';
import { CustomProductListEffectsService } from './custom-product-list-effect.service';
import { GlobalService } from '../../../../SGRE-shared/services/global.service';
import { UserRoles } from '../../../../SGRE-shared/constants/app-constant';

@Injectable()
export class CustomProductListEffects {

  protected logger = inject(LoggerService);

  constructor(
    private actions$: Actions,
    private apiService: ApiService,
    private authService: AuthService,
    private productSearchEffectsService: CustomProductListEffectsService,
    private globalService: GlobalService,
  ) { }

  handleProductSearchFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductActions.SEARCH_PRODUCTS_FAIL),
      map(({ payload, auxiliary }) => {
        const data = this.productSearchEffectsService.handleError(tryNormalizeHttpError(payload, this.logger));
        return new ProductActions.SearchProductsSuccess(
          data,
          auxiliary
        );
      })
    )
  );

  loadPricesBatchAfterProductsSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomProductActions.loadProductsSuccess),
      filter(() => this.globalService.getUserId() !== UserRoles.ANONYMOUS),
      concatMap(({ products }) => {
        const productCodes = products
          .filter(p => p.isCachePrice === false)
          .map(p => p.code);
        return of(
          CustomProductActions.loadPricesBatch({ productCodes: productCodes })
        ).pipe(delay(100));
      })
    )
  );

  loadPricesBatch$ = createEffect((): any =>
    this.actions$.pipe(
      ofType(CustomProductActions.loadPricesBatch),
      switchMap(({ productCodes }) =>
        this.authService.isUserLoggedIn().pipe(
          filter(isLoggedIn => isLoggedIn),
          switchMap(() => {
            const batches = [];
            for (let i = 0; i < productCodes.length; i += 6) {
              batches.push(productCodes.slice(i, i + 6));
            }
            if (!batches.length) {
              return EMPTY;
            }
            return from(batches).pipe(
              mergeMap((batch) =>
                this.apiService.getTopProductsPriceList(batch).pipe(
                  mergeMap((prices) => {
                    const actions = prices.body.priceItems.map((priceObj) => {
                      if (priceObj.message && priceObj.message !== 8 && priceObj.message !== 4 && priceObj.message !== 9) {
                        return CustomProductActions.loadPricesBatchFailure({
                          productCode: priceObj.code,
                          error: priceObj.message || { message: 'Price fetch failed' }
                        });
                      }
                      return CustomProductActions.loadPricesBatchSuccess({
                        productCode: priceObj.code,
                        discountPriceData: priceObj.discountPriceData,
                        quotationFlag: priceObj.quotationFlag,
                        obsoleteFlag: priceObj.obsoleteFlag
                      });
                    });

                    return from(actions);
                    ;
                  }),
                  catchError((error) => from(batch.map(code => CustomProductActions.loadPricesBatchFailure({ productCode: code, error }))))
                )
              ),
            );
          })
        )
      )
    )
  );
}